import { DeleteFolderDialog } from "@/action-dialog/dialogs/DeleteFolderDialog";
import type { Folder } from "@cohesive/api-client";
import { useRef } from "react";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type DeleteFolderCallableProps = {
  workspaceId: string;
  folder: Folder;
};

export const DeleteFolderCallable = createCallable<
  DeleteFolderCallableProps,
  boolean
>(({ call, workspaceId, folder }) => {
  const succeededRef = useRef(false);

  return (
    <DeleteFolderDialog
      workspaceId={workspaceId}
      folder={folder}
      onClose={() => {
        call.end(succeededRef.current);
        succeededRef.current = false;
      }}
      onSuccess={() => {
        succeededRef.current = true;
      }}
    />
  );
}, UNMOUNTING_DELAY_MS);

DeleteFolderCallable.displayName = "DeleteFolderCallable";
